export const GET_CREDS = "GET_CREDS";
export const SELECT_CRED = "SELECT_CRED";
export const DELETE_CRED = "DELETE_CRED";
export const UPDATE_CRED = "UPDATE_CRED";
export const MODIFY_SELECTED_CRED = "MODIFY_SELECTED_CRED";
export const DISCARD_CRED = "DISCARD_CRED";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const GET_FLOWS = "GET_FLOWS";
export const MODIFIED_SELECTED_FLOW = "MODIFIED_SELECTED_FLOW";
export const SET_PAGE = "SET_PAGE";
export const SET_SECTION = "SET_SECTION";
export const SAVE_FLOW = "SAVE_FLOW";
export const SAVE_FLOW_ONLY = "SAVE_FLOW_ONLY";
export const CREATE_FLOW = "CREATE_FLOW";
export const SET_SAVED = "SET_SAVED";
export const SET_URL = "SET_URL";
export const SET_RENDER = "SET_RENDER";
export const SET_FLOW_EDIT_LOCK = "SET_FLOW_EDIT_LOCK";
export const SET_FLOW_RUNNER_STATUS = "SET_FLOW_RUNNER_STATUS";

export const SET_SELECTED_ACTION_ID = "SET_SELECTED_ACTION_ID";
export const GET_LOGS = "GET_LOGS";
export const GET_LOG_ITEM = "GET_LOG_ITEM";
export const CLEAR_LOG = "CLEAR_LOG";
export const GET_NEXT_LOG_PAGE = "GET_NEXT_LOG_PAGE";
export const GET_ATTACHMENT_LOGS = "GET_ATTACHMENT_LOGS";
export const CLEAR_ATTACHMENT_LOGS = "CLEAR_ATTACHMENT_LOGS";
export const DELETE_FLOW = "DELETE_FLOW";
export const PREVIEW_REQUEST = "PREVIEW_REQUEST";
export const RESOLVE_REQUEST = "RESOLVE_REQUEST";
export const AUTHORIZE = "AUTHORIZE";

//JIRA
export const JQL_SEARCH = "JQL_SEARCH";
export const JIRA_CF_FIELDS = "JIRA_CF_FIELDS";
export const JIRA_ISSUE = "JIRA_ISSUE";
export const JIRA_LICENSE = "JIRA_LICENSE";
export const JIRA_PROJECT = "JIRA_PROJECT";
export const JIRA_ISSUE_TYPE = "JIRA_ISSUE_TYPE";
export const JIRA_USER_INFO = "JIRA_USER_INFO";
export const JIRA_ADMIN_PERMISSION = "JIRA_ADMIN_PERMISSION";
export const APP_WEB_LOCATION_IN_JIRA = "APP_WEB_LOCATION_IN_JIRA";

//Notifications
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";
//Test flow
export const TEST_FLOW = "TEST_FLOW";
export const TEST_SCRIPT = "TEST_SCRIPT";
//Wizard
export const SHOW_WIZARD = "SHOW_WIZARD";
export const SET_CURRNET_WIZRD_PAGE = "SET_CURRNET_WIZRD_PAGE";
export const SET_CURRNET_WIZRD = "SET_CURRNET_WIZRD";
export const SET_WIZARD_ERROR_MESSAGE = "SET_WIZARD_ERROR_MESSAGE";
export const SET_WIZARD_CATEGORY = "SET_WIZARD_CATEGORY";
export const SET_CURRENT_WIZARD_DATA = "SET_CURRENT_WIZARD_DATA";
export const CLEAR_WIZARD = "CLEAR_WIZARD";

//Jira Assets
export const GET_ASSET_WORKSPACE = "GET_ASSET_WORKSPACE";
export const CREATE_ASSET_IMPORT_SOURCE = "CREATE_ASSET_IMPORT_SOURCE";
export const CREATE_ASSET_IMPORT_TOKEN = "CREATE_ASSET_IMPORT_TOKEN";
export const GET_ASSET_SCHEMAS = "GET_ASSET_SCHEMAS";
export const SET_SELECTED_ASSET_SCHEMA = "SET_SELECTED_ASSET_SCHEMA";
export const SET_IMPORT_SOURCE_NAME = "SET_IMPORT_SOURCE_NAME";
export const SET_OBJECT_TYPE_NAME = "SET_OBJECT_TYPE_NAME";
export const CLEAR_ASSET = "CLEAR_ASSET";

//Backups & Restore
export const LIST_BACKUPS_FOR_FLOW = "LIST_BACKUPS_FOR_FLOW";
export const LIST_BACKUPS_FOR_CRED = "LIST_BACKUPS_FOR_CRED";
export const GET_BACKUP = "GET_BACKUP";
export const GET_ALL_FLOWS_WITH_BACKUPS = "GET_ALL_FLOWS_WITH_BACKUPS";
export const GET_BACKUP_TOKEN = "GET_BACKUP_TOKEN";
export const SET_VERSION_INFO = "SET_VERSION_INFO";
